module.exports = {"610118001":"甘亭街道办","610118101":"余下镇","610118102":"祖庵镇","610118103":"秦渡镇","610118104":"大王镇","610118105":"草堂镇","610118106":"蒋村镇","610118107":"庞光镇","610118108":"涝店镇","610118109":"甘河镇","610118110":"石井镇","610118111":"玉蝉镇","610118112":"五竹镇","610118114":"渭丰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610118.json
// module id = 2786
// module chunks = 0